<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.50781 21.1749V19.5879H21.5448V21.1749H2.50781Z"
      fill="#FFC304"
    />
    <path
      d="M4.17222 15.6742L1.44922 11.0472L2.58622 10.8352L4.43722 12.4742L10.4132 10.8612L5.89122 3.27322L7.42522 2.82422L14.9612 9.62422L20.6722 8.09022C20.8923 8.01717 21.1274 8.00189 21.355 8.04584C21.5827 8.08979 21.7952 8.1915 21.9722 8.34122C22.1597 8.48531 22.3102 8.67188 22.4114 8.88556C22.5126 9.09924 22.5615 9.3339 22.5542 9.57022C22.5541 9.89393 22.4482 10.2087 22.2524 10.4666C22.0567 10.7244 21.782 10.9111 21.4702 10.9982L4.17222 15.6742Z"
      fill="#21BF54"
    />
  </svg>
</template>
<script>
export default {
  props: {
    width: {
      type: Number,
      default: 24,
    },
    height: {
      type: Number,
      default: 24,
    },
  },
};
</script>
